"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColumnsV3Service", {
    enumerable: true,
    get: function() {
        return ColumnsV3Service;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _ncError = require("~/helpers/ncError");
const _columnwebhookmanager = require("~/utils/column-webhook-manager");
const _columnsservice = require("~/services/columns.service");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _apiv3datatransformationbuilder = require("~/utils/api-v3-data-transformation.builder");
const _helpers = require("~/helpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ColumnsV3Service = class ColumnsV3Service {
    async columnUpdate(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_columnWebhookManager, _ref;
        var _param_column;
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/FieldUpdate', param.column, true, context);
        if (param.column.type) {
            (0, _helpers.validatePayload)(`swagger-v3.json#/components/schemas/FieldOptions/${param.column.type}`, param.column, true, context);
        }
        let column = await _models.Column.get(context, {
            colId: param.columnId
        }, ncMeta);
        if (!column) {
            _ncError.NcError.get(context).fieldNotFound(param.columnId);
        }
        const columnWebhookManager = (_param_columnWebhookManager = param.columnWebhookManager) != null ? _param_columnWebhookManager : (await new _columnwebhookmanager.ColumnWebhookManagerBuilder(context, ncMeta).withModelId(column.fk_model_id)).addColumn(column).forUpdate();
        const type = (_ref = (_param_column = param.column) == null ? void 0 : _param_column.type) != null ? _ref : column.uidt;
        const processedColumnReq = (0, _apiv3datatransformationbuilder.columnV3ToV2Builder)().build(_extends({}, param.column, {
            type
        }));
        if (!processedColumnReq.column_name) {
            processedColumnReq.column_name = column.column_name;
        }
        if (!processedColumnReq.title) {
            processedColumnReq.title = column.title;
        }
        if ([
            _nocodbsdk.UITypes.SingleSelect,
            _nocodbsdk.UITypes.MultiSelect
        ].includes(column.uidt)) {
            var _column_colOptions_options, _column_colOptions;
            if (column.meta) {
                column.meta.choices = undefined;
            }
            column.dtxp = (_column_colOptions = column.colOptions) == null ? void 0 : (_column_colOptions_options = _column_colOptions.options) == null ? void 0 : _column_colOptions_options.map((o)=>`'${o.value}'`).join('');
        }
        // in payload id is required in existing implementation
        column.id = param.columnId;
        await this.columnsService.columnUpdate(context, _extends({}, param, {
            column: processedColumnReq,
            apiVersion: _nocodbsdk.NcApiVersion.V3,
            req: param.req,
            columnWebhookManager: columnWebhookManager
        }), ncMeta);
        column = await _models.Column.get(context, {
            colId: param.columnId
        });
        // do tranformation
        const v3Response = (0, _apiv3datatransformationbuilder.columnBuilder)().build(column);
        if (!param.columnWebhookManager) {
            await columnWebhookManager.populateNewColumns();
            columnWebhookManager.emit();
        }
        return v3Response;
    }
    async columnGet(context, param) {
        const column = await _models.Column.get(context, {
            colId: param.columnId
        });
        if (!column) {
            _ncError.NcError.get(context).fieldNotFound(param.columnId);
        }
        return (0, _apiv3datatransformationbuilder.columnBuilder)().build(column);
    }
    async columnAdd(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_columnWebhookManager;
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/CreateField', param.column, true, context);
        (0, _helpers.validatePayload)(`swagger-v3.json#/components/schemas/FieldOptions/${param.column.type}`, param.column, true, context);
        const columnWebhookManager = (_param_columnWebhookManager = param.columnWebhookManager) != null ? _param_columnWebhookManager : (await new _columnwebhookmanager.ColumnWebhookManagerBuilder(context, ncMeta).withModelId(param.tableId)).forCreate();
        const column = (0, _apiv3datatransformationbuilder.columnV3ToV2Builder)().build(param.column);
        // if LTAR column then define tablr id as parent id in request
        if ((0, _nocodbsdk.isLinksOrLTAR)(column) && !column.parentId) {
            column.parentId = param.tableId;
        }
        if ([
            _nocodbsdk.UITypes.SingleSelect,
            _nocodbsdk.UITypes.MultiSelect
        ].includes(column.uidt)) {
            var _column_colOptions_options, _column_colOptions;
            if (column.meta) {
                column.meta.choices = undefined;
            }
            column.dtxp = (_column_colOptions = column.colOptions) == null ? void 0 : (_column_colOptions_options = _column_colOptions.options) == null ? void 0 : _column_colOptions_options.map((o)=>`${o.value}`).join('');
        }
        const res = await this.columnsService.columnAdd(context, _extends({}, param, {
            column,
            apiVersion: _nocodbsdk.NcApiVersion.V3,
            columnWebhookManager: columnWebhookManager
        }), ncMeta);
        // do tranformation
        const v3Response = (0, _apiv3datatransformationbuilder.columnBuilder)().build(res);
        await columnWebhookManager.addNewColumn({
            column: v3Response,
            action: _nocodbsdk.WebhookActions.INSERT
        });
        if (!param.columnWebhookManager) {
            columnWebhookManager.emit();
        }
        return v3Response;
    }
    async columnDelete(context, param, ncMeta = _Noco.default.ncMeta) {
        await this.columnsService.columnDelete(context, param, ncMeta);
        return {};
    }
    constructor(columnsService){
        this.columnsService = columnsService;
    }
};
ColumnsV3Service = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService
    ])
], ColumnsV3Service);
